
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8661"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8661"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
/**
 * Player addition in the list. Remove all players in the list.
 */ 
var $iZbq8 = parcelRequire("iZbq8");
const $8e6c331762d303f4$var$addPlayerInput = document.getElementById("add-player-input");
const $8e6c331762d303f4$var$playerForm = document.getElementById("player-form");
$8e6c331762d303f4$var$playerForm.addEventListener("submit", (e)=>{
    e.preventDefault();
    const clone = document.importNode((0, $iZbq8.listItemTemplate).content, true);
    clone.querySelector(".player-name").textContent = $8e6c331762d303f4$var$addPlayerInput.value;
    (0, $iZbq8.playersList).insertBefore(clone, (0, $iZbq8.removeDiv));
    $8e6c331762d303f4$var$addPlayerInput.value = "";
    (0, $iZbq8.updatePlayersList)();
});
(0, $iZbq8.deleteAllButton).addEventListener("click", ()=>{
    (0, $iZbq8.playersListItems).forEach((item)=>{
        item.remove();
    });
    (0, $iZbq8.updatePlayersList)();
    (0, $iZbq8.startNextButton).textContent = "Inicia";
    (0, $iZbq8.pauseButton).textContent = "Pausen";
    (0, $iZbq8.resetButton).textContent = "Restableix";
});


//# sourceMappingURL=rummiclock.0dbea9df.js.map
